/**
 * 用来解决local-storage 在隐身模式下的报错增加给localStorage设置过期时间功能
 * 实现方式 将过期时间存在key的value里面 设置的值统一为 {key: '设置的值', expires: '过期时间 没有设置过期时间的为-1 '}
 */
// TODO 函数排序
define('data/local-storage', () => {
    /**
     * 设置localStorage的值 设置成功返回设置的值 设置失败返回false
     * @param key (string)
     * @param value (string)
     * @param expireTimeInSecond 过期时间 单位秒
     * @returns 真实给localStorage设置上的值
     */
    function setItem(key, value, expireTimeInSecond = -1) {
        let realValue = {};
        if (!key) {
            return false;
        }
        realValue.value = value;
        realValue.expires = Date.now() + expireTimeInSecond * 1000;
        if (expireTimeInSecond === -1) {
            realValue.expires = expireTimeInSecond;
        }
        realValue = JSON.stringify(realValue);
        try {
            localStorage.setItem(key, realValue);
        } catch (e) {
            return false;
        }
        return realValue;
    }

    /**
     * 清除指定的key
     * @param key
     * @returns key
     */
    function removeItem(key) {
        if (typeof key !== 'string') {
            return;
        }
        try {
            localStorage.removeItem(key);
            return key;
        } catch (e) {} // eslint-disable-line
    }

    /**
     * 获取存储的Key的value
     * @param key
     * @returns key对应的value
     */
    function getItem(key) {
        if (typeof key !== 'string') {
            return null;
        }
        let value;
        try {
            value = localStorage.getItem(key);
        } catch (e) {
            return null;
        }
        if (!value) {
            return value;
        }
        let valueObj;
        try {
            valueObj = JSON.parse(value);
        } catch (e) {
            return value;
        }
        // 没有设置过期时间的
        if (valueObj.expires === -1) {
            return valueObj.value;
        }
        if (Date.now() > valueObj.expires) {
            // 过期处理
            removeItem(key);
            return null;
        }
        // 未过期处理
        return valueObj.value;
    }

    return {
        removeItem,
        getItem,
        setItem,
    };
});
